import React from 'react';
import NavBar from '../../components/common/Header/NavBar';
import { useViewport } from '../../helpers/hooks/commonHooks';
import { DESKTOP_SD_VIEWPORT_SIZE, IS_SHOW_TV_CONTENT } from '../../constants/configuration';
import { useTranslation } from 'react-i18next';

const NavBarContainer = () => {
  const { t } = useTranslation();

  const { viewportWidth } = useViewport();

  return (
    <NavBar
      isVisible={viewportWidth >= DESKTOP_SD_VIEWPORT_SIZE}
      navBarRoutes={t(IS_SHOW_TV_CONTENT ? 'header.navWithTvContent' : 'header.nav', {
        returnObjects: true
      })}
      navBarClassName="HeaderNav"
    />
  );
};

export default NavBarContainer;
